import { useEffect, useRef, useState } from "react";
import Lenis from "lenis";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Services from "@/components/site/Services";
import Gallery from "@/components/site/Gallery";
import About from "@/components/site/About";
import Testimonials from "@/components/site/Testimonials";
import News from "@/components/site/News";
import Footer from "@/components/site/Footer";
import Reveal from "@/components/site/Reveal";
import BookingModal from "@/components/site/BookingModal";

export default function Home() {
  const lenisRef = useRef(null);
  const [booking, setBooking] = useState({ open: false, service: null });
  const openBooking = (service = null) => setBooking({ open: true, service });
  const closeBooking = () => setBooking({ open: false, service: null });

  useEffect(() => {
    booking.open ? lenisRef.current?.stop() : lenisRef.current?.start();
  }, [booking.open]);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    lenisRef.current = lenis;
    const onClick = (e) => {
      const anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;
      const target = document.querySelector(anchor.getAttribute("href"));
      if (target) {
        e.preventDefault();
        lenis.scrollTo(target, { offset: -72 });
      }
    };
    document.addEventListener("click", onClick);
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      document.removeEventListener("click", onClick);
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div data-testid="home-page" className="min-h-screen bg-cream text-obsidian">
      <Header onBook={openBooking} />
      <main>
        <Hero onBook={openBooking} />
        <Marquee />
        <Reveal>
          <Services onBook={openBooking} />
        </Reveal>
        <Reveal>
          <Gallery />
        </Reveal>
        <Reveal>
          <About />
        </Reveal>
        <Reveal>
          <Testimonials />
        </Reveal>
        <Reveal>
          <News />
        </Reveal>
      </main>
      <Footer onBook={openBooking} />
      <BookingModal open={booking.open} initialService={booking.service} onClose={closeBooking} />
    </div>
  );
}
